import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["level", "container"];

	connect() {
		this.showLevel(this.levelTargets[0]?.value);
	}

	selectLevel(event) {
		const selectedLevel = event.target.value;
		this.showLevel(selectedLevel);
	}

	showLevel(level) {
		this.containerTargets.forEach((container) => {
			container.classList.add("hidden");
			container.classList.remove("flex");
		});

		const selectedContainer = this.containerTargets.find((container) => container.dataset.level === level);

		if (selectedContainer) {
			selectedContainer.classList.remove("hidden");
			selectedContainer.classList.add("flex");
		}
	}
}
